// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__1btUG","item":"Navbar_item__1OZRd","active":"Navbar_active__1QdTT"};